(function () {
  angular
    .module('kareo.ui.shared.directives.k-create-insurance-company', [
      'kareo.ui.shared.directives.validation.input-group',
      'kareo.ui.shared.directives.patient-create.services',
      'kareo.ui.shared.directives.validation.prevent-form-submit',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.ui-mask',
      'kareo.ui.shared.modules.api.insurance-service'
    ])
    .directive('kCreateInsuranceCompany', kCreateInsuranceCompany);

  function kCreateInsuranceCompany() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        onSuccess: '&',
        onCancel: '&'
      },
      template: require('./k-create-insurance-company.pug')()
    };
  }

  controller.$inject = ['insuranceService'];

  function controller(insuranceService) {
    var vm = this;

    resetState();

    vm.confirmInsuranceCompany = function () {
      vm.savingInsuranceCompany = true;
      var createCompany = insuranceService.createInsuranceCompany(
        { insuranceCompanyName: vm.companyName });

      vm.savingInsuranceCompany = true;
      createCompany.then((data) => {
        vm.savingInsuranceCompany = false;
        vm.closeSuccess({
          insuranceCompanyId: data,
          insuranceCompanyName: vm.companyName
        });
      }, () => {
        vm.savingInsuranceCompany = false;
        vm.errorCreatingCompany = true;
      });
    };

    vm.closeSuccess = function (newCompany) {
      vm.onSuccess({ company: newCompany });
      resetState();
    };

    vm.closeCancel = function () {
      vm.onCancel();
      resetState();
    };

    function resetState() {
      vm.savingInsuranceCompany = false;
      vm.errorCreatingCompany = false;
      vm.companyName = '';
    }
  }
})();
